<template>
    <div class="rule_card">
        <div class="rule_title">{{ $t('rulecard.communicationRules') }}</div>
        <div class="rule_details">
            <van-row>
                <van-col span="6" class="faq_head_img">
                    <img src="@/assets/agent/atividades_faq_head_1.png" alt="">
                </van-col>
                <van-col span="18" class="faq_head">
                    <div class="text1">{{ $t('rulecard.faqHead1') }}</div>
                    <div class="text2"><span>110</span>{{ $t('rulecard.faqHead2') }}</div>
                </van-col>
            </van-row>

            <van-row style="padding: 10px 0;">
                <van-col span="20" class="perfo_title">{{ $t('rulecard.perfoTitle1') }}</van-col>
                <van-col span="4" class="perfo_value"><span>{{ total_performance }}</span></van-col>
                <van-col span="20" class="perfo_title">{{ $t('rulecard.perfoTitle2') }}</van-col>
                <van-col span="4" class="perfo_value"><span>{{ sub_performance }}</span></van-col>
                <van-col span="20" class="perfo_title">{{ $t('rulecard.perfoTitle3') }}</van-col>
                <van-col span="4" class="perfo_value"><span>{{ total_performance - sub_performance }}</span></van-col>
            </van-row>
            <van-row style="margin: 15% 0;">
                <van-col span="8" class="arrowContent">
                    <img src="@/assets/agent/atividades_faq_icon_2.png" alt="">
                    <div class="tip_text1">{{ $t('rulecard.tipText1') }} <span>1320</span></div>
                    <div class="tip_text2">{{ $t('rulecard.tipText2') }} <span>520</span></div>
                </van-col>
                <van-col span="8" class="arrowContent">
                    <img src="@/assets/agent/atividades_faq_icon_3.png" alt="">
                    <div class="tip_text3">{{ $t('rulecard.tipText3') }} A:<span>440</span></div>
                </van-col>
                <van-col span="8" class="arrowContent">
                    <img src="@/assets/agent/atividades_faq_icon_4.png" alt="">
                    <div class="tip_text4">{{ $t('rulecard.tipText4') }} <span>0</span></div>
                    <div class="tip_text5">{{ $t('rulecard.tipText5') }} <span>220</span></div>
                </van-col>
            </van-row>

            <van-row>
                <van-col span="8" class="bet_column">
                    <BetCard :content="$t('rulecard.subAgentWins')" infoValue="70" bottomText="120K"
                        :cardImage="require('@/assets/agent/atividades_faq_head_2.png')"
                        topBackground="rgba(240, 168, 83, 0.50)" downBackground="#F0A853" />
                </van-col>
                <van-col span="8" class="bet_column">
                    <BetCard :content="$t('rulecard.noProfit')" bottomText="120K"
                        :cardImage="require('@/assets/agent/atividades_faq_head_3.png')"
                        topBackground="rgba(240, 168, 83, 0.50)" downBackground="#F0A853" />
                </van-col>
                <van-col span="8" class="bet_column">
                    <BetCard :content="$t('rulecard.wins')" infoValue="70" bottomText="120K"
                        :cardImage="require('@/assets/agent/atividades_faq_head_4.png')"
                        topBackground="rgba(240, 168, 83, 0.50)" downBackground="#F0A853" />
                </van-col>
            </van-row>

            <div class="tip_frame2" style="margin-bottom: 15px;">
               
                
                

                <van-row>
                    <van-col span="8" class="tip_text6">
                         <img src="@/assets/agent/atividades_faq_icon_3.png" alt="">
                        <div>{{ $t('rulecard.tipText3') }} A: <span>400</span></div>
                        <div>{{ $t('rulecard.tipText3') }} B1: <span>700</span></div>
                    </van-col>
                    <van-col span="8" class="tip_text6">
                        <img style="margin-left: -70%;" src="@/assets/agent/atividades_faq_icon_4.png" alt="">
                        <div>{{ $t('rulecard.tipText3') }} A: <span>120</span></div>
                        <div>{{ $t('rulecard.tipText3') }} B2: <span>210</span></div>
                    </van-col>
                    <van-col span="8" class="tip_text6">
                        <img src="@/assets/agent/atividades_faq_icon_3.png" alt="">
                        <div>{{ $t('rulecard.tipText3') }} A: <span>0</span></div>
                        <div>{{ $t('rulecard.tipText3') }} B3: <span>33000</span></div>
                    </van-col>
                </van-row>
            </div>

            <van-row>
                <van-col span="8" class="bet_column">
                    <BetCard :content="$t('rulecard.subAgentWins')" infoValue="70" bottomText="120K"
                        :cardImage="require('@/assets/agent/atividades_faq_head_5.png')" topBackground="#DD7A33"
                        downBackground="#FF780D" />
                </van-col>
                <van-col span="8" class="bet_column">
                    <BetCard :content="$t('rulecard.noProfit')" bottomText="120K"
                        :cardImage="require('@/assets/agent/atividades_faq_head_6.png')" topBackground="#DD7A33"
                        downBackground="#FF780D" />
                </van-col>
                <van-col span="8" class="bet_column">
                    <BetCard :content="$t('rulecard.wins')" infoValue="70" bottomText="120K"
                        :cardImage="require('@/assets/agent/atividades_faq_head_7.png')" topBackground="#DD7A33"
                        downBackground="#FF780D" />
                </van-col>
            </van-row>

            <div class="rules_text">
                <div class="text_title">{{ $t('rulecard.exampleTitle') }}</div>
                <div class="text_content" v-html="$t('rulecard.exampleContent')"></div>
                <div class="text_title">{{ $t('rulecard.exampleTitle2') }}</div>
                <div class="text_content" v-html="$t('rulecard.exampleContent2')">
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import BetCard from './betCard.vue';

const total_performance = 2500;
const sub_performance = 1980
</script>

<style scoped>
.rule_card {
    border-radius: 10px;
    background-image: linear-gradient(180deg, rgba(255, 255, 255, 0.15) 0%, rgba(255, 255, 255, 0.00) 100%);
    border: 1px solid rgba(255, 255, 255, 0.15);
    margin: 10px 0;
}

.rule_card span {
    color: #FFEE00;
    padding: 0 5px;
}

.rule_title {
    color: rgba(255, 255, 255, 0.85);
    border-radius: 10px;
    background-image: linear-gradient(90deg, rgba(255, 255, 255, 0.00) 0%, rgba(255, 255, 255, 0.25) 100%);
    font-size: 22px;
    font-weight: 700;
    color: #FFFFFF;
    text-align: center;
    padding: 25px 0;
}

.rule_details {
    padding: 15px 15px 5px;
}

.faq_head_img img {
    width: 100%;
}

.faq_head {
    color: rgba(255, 255, 255, 0.65);
    padding: 0 15px;
    line-height: 20px;
}

.text1 {
    font-size: 15px;
    padding: 5px;
}

.text2 {
    font-size: 18px;
    padding: 5px;
}

.perfo_title {
    padding: 5px 0;
    font-size: 12px;
}

.perfo_value {
    font-size: 15px;
    text-align: right;
}

.arrowContent {
    position: relative;
    display: flex;
    align-items: center;
    flex-direction: column;
    text-align: center;
    font-size: 11px;
}

.arrowContent img {
    width: 60%;
}

.tip_frame {
    font-size: 11px;
    position: relative;
    padding: 15px 15px 0;
    height: 140px;
}

.tip_frame2 {
    font-size: 11px;
    position: relative;
    padding: 15px 5px 0;
}

.tip_frame2 span {
    font-weight: bold;
}

.tip_frame2 img {
    width: 70%;
}

.tip_frame span {
    font-weight: bold;
}

.tip_frame img {
    width: 75px;
}

.arrow_img1 {
    position: absolute;
    left: 45px;
    top: 30px;
}

.arrow_img2 {
    position: absolute;
    left: 40%;
    top: 10px;
}

.arrow_img3 {
    position: absolute;
    left: 65%;
    top: 30px;
}

.tip_text1 {
    text-align: center;
    position: absolute;
    top: 5%;
    left: -15%;
    transform: rotate(-45deg);
    width: 95%;

}

.tip_text2 {
    text-align: center;
    position: absolute;
    top: 60%;
    left: 15%;
    transform: rotate(-45deg);
    width: 100%;
}

.tip_text3 {
    padding-top: 10%;
}

.tip_text4 {
    text-align: center;
    position: absolute;
    top: 50%;
    right: 10%;
    transform: rotate(45deg);
    width: 130%;
}

.tip_text5 {
    text-align: center;
    position: absolute;
    right: -15%;
    top: 0%;
    transform: rotate(45deg);
    width: 95%;
}

.bet_column {
    padding: 0 5px;
}

.arrow_img4 {
    padding-left: 10px;
}

.arrow_img6 {
    padding-left: 70px;
}

.tip_text6 {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    flex-direction: column;
    padding: 0 5px;
}

.rules_text {
    padding: 15px 5px 0;
    line-height: 22px;
}

.text_title {
    color: rgba(255, 255, 255, 0.85);
    font-weight: 700;
    font-size: 16px;
}

.text_content {
    color: rgba(255, 255, 255, 0.65);
    font-weight: 400;
    font-size: 13px;
    padding-bottom: 10px;
}
</style>